import { blue, green, grey, orange, red } from "./colors/index.js";
import { action } from "./action.js";
import { background } from "./background.js";
import { error } from "./error.js";
import { greyOption } from "./grey.js";
import { primary } from "./primary.js";
import { secondary } from "./secondary.js";
import { text as external_text_js_text } from "./text.js";
import { warning } from "./warning.js";
import { info } from "./info.js";
import { success } from "./success.js";
import { status as index_js_status } from "./status/index.js";
import { border } from "./border.js";
import { illustration } from "./illustration.js";
function getPaletteOptions(mode) {
    return {
        mode,
        primary: primary(mode),
        secondary: secondary(mode),
        grey: greyOption(mode),
        background: background(mode),
        action: action(mode),
        text: external_text_js_text(mode),
        error: error(mode),
        warning: warning(mode),
        info: info(mode),
        success: success(mode),
        designSystem: {
            blue: blue,
            green: green,
            grey: grey,
            orange: orange,
            red: red
        },
        status: index_js_status(mode),
        border: border(mode),
        illustration: illustration(mode),
        contrastThreshold: 4.5
    };
}
export { getPaletteOptions };

//# sourceMappingURL=palette-options.js.map